import React from 'react';
import Button from '../../../UI/Button/Button';

const summaryButtons = (props) => {
  let continueButtonText = 'Log in to continue';
  if (props.isAuth) {
    continueButtonText = 'Continue';
  }
  return (<div>
    <Button btnType='Danger' clicked={props.cancel}>Cancel</Button>
    <Button btnType='Success' clicked={props.continue}>{continueButtonText}</Button>
  </div>
  );
}

export default summaryButtons;


// WEBPACK FOOTER //
// ./src/components/Burger/OrderSummary/SummaryButtons/SummaryButtons.jsx